export const sortCollection = (a: any, b: any) => {
    const valueA = a.collectionName;
    const valueB = b.collectionName;

    if (valueA.startsWith('Shared') && !valueB.startsWith('Shared')) {
        return -1;
    }
    if (!valueA.startsWith('Shared') && valueB.startsWith('Shared')) {
        return 1;
    }
    if (valueA < valueB) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }
    return 0;
};
